import { of } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { esbApi } from '@modules/rtk/esb-api';
import esbApiService from '@utils/http/esbApiService';

import { transformOrgProfile } from './utils';

/**
 * @esbEndpoint GET /organizations/v2/:orgGuid/profile
 */
const getUnitInfo$ = (
  guid,
  /** @type {import('@reduxjs/toolkit').ThunkDispatch} */
  dispatch,
) => {
  const flagEnabled = featureFlags.getFlag('SBL_5515_RTK_ORG_PROFILE');

  if (flagEnabled && dispatch) {
    const thunk = dispatch(
      esbApi.endpoints.getOrganizationProfile.initiate({
        orgGuid: guid,
      }),
    ).then(result => result.data);
    return Observable.fromPromise(thunk);
  }

  return esbApiService
    .get$(`/organizations/v2/${guid}/profile`, {
      suppressErrorToasts: [404],
      suppressSentry: [404],
      gtm: {
        label: '/organizations/v2/{guid}/profile',
      },
    })
    .pipe(
      map(transformOrgProfile),
      catchError(err => {
        if (err.status !== 404) {
          throw err;
        }
        return of({});
      }),
    );
};

export default {
  getUnitInfo$,
};
